import { render, staticRenderFns } from "./MicrosoftIntegration.vue?vue&type=template&id=1595bd04&"
import script from "./MicrosoftIntegration.vue?vue&type=script&lang=js&"
export * from "./MicrosoftIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports